import BFFProxy from './bffProxy';
import axiosWithPayloadInterceptor from '../interceptor/axiosWithPayloadInterceptor';
import {
  HTTP_METHODS,
  HTTP_STATUS,
  URLS,
  FILE_TYPES
} from '../helpers/constants';
import {
  S3_FILE_UPLOAD_ERROR,
  FILE_IMPORT_ERROR,
  UNSUPPORTED_CSV_FILE_FORMAT,
  FILE_CONTAINS_MULTIPLE_AGREEMENTS,
  EMPTY_FILE,
} from '../helpers/messageConstant';

/**
 *
 * @author agal0301
 */
class MassItemUploadProxy {
  static async getMassItemAssociationFile(file) {
    try {
      const signedUrlResponse = await BFFProxy.getSignedUrlToUpload(FILE_TYPES.ITEM_GROUP_MASS_ITEM_ASSOCIATION_FILE, file.name);
      const s3UploadResponse = await BFFProxy.uploadWithSignedUrl(signedUrlResponse.data.url, file, file.type);
      if (s3UploadResponse.status === HTTP_STATUS.OK) {
        const config = {
          url: `${URLS.ITEM_GROUP_MANAGEMENT_BASE_URL}/upload`,
          params: {
            filename: encodeURIComponent(signedUrlResponse.data.fileName),
          },
          method: HTTP_METHODS.GET
        };
        const response = await axiosWithPayloadInterceptor(config);
        return { massItemFileImportResponse: response.data, importedFileName: signedUrlResponse.data.fileName };
      }
      return Promise.reject(new Error(S3_FILE_UPLOAD_ERROR));
    } catch (e) {
      const errorMessage = e.response?.data;
      if (errorMessage && (errorMessage === UNSUPPORTED_CSV_FILE_FORMAT || errorMessage === FILE_CONTAINS_MULTIPLE_AGREEMENTS || errorMessage === EMPTY_FILE)) return Promise.reject(new Error(e.response.data));
      return Promise.reject(new Error(FILE_IMPORT_ERROR));
    }
  }

  static async validateMassItemAssignmentData(data) {
    const url = `${URLS.ITEM_GROUP_MANAGEMENT_BASE_URL}/validate`;
    const config = {
      url,
      method: HTTP_METHODS.POST,
      data
    };
    const response = await axiosWithPayloadInterceptor(config);
    return response.data;
  }

  static async uploadMassItemAssignmentData(data) {
    const url = `${URLS.ITEM_GROUP_MANAGEMENT_BASE_URL}/assign`;
    const config = {
      url,
      method: HTTP_METHODS.POST,
      data
    };
    const response = await axiosWithPayloadInterceptor(config);
    return response.data;
  }
}

export default MassItemUploadProxy;
